var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17457",
    "data-name": "Group 17457",
    transform: "translate(-1339.5 -18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15491",
    "data-name": "Path 15491",
    d: "M1351.5,41.25A11.25,11.25,0,1,0,1340.25,30,11.252,11.252,0,0,0,1351.5,41.25Z",
    fill: "#d1d1d1",
    stroke: "#d1d1d1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15492",
    "data-name": "Path 15492",
    d: "M1351.63,30.878a1.088,1.088,0,0,0-.27,0,3.695,3.695,0,1,1,.27,0Z",
    fill: "#7d7d7e",
    stroke: "#7d7d7e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15493",
    "data-name": "Path 15493",
    d: "M1359.08,38.3a11.22,11.22,0,0,1-15.16,0,4.14,4.14,0,0,1,1.99-2.9,10.942,10.942,0,0,1,11.18,0A4.11,4.11,0,0,1,1359.08,38.3Z",
    fill: "#7d7d7e",
    stroke: "#7d7d7e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.ca6b17ca7260ce3f18ef6f3f9d5d74ed.svg";
export { ForwardRef as ReactComponent };